import { cn } from "./utils";

/**
 * Admin oldalak gyökéreleme: Klasszikus = szokásos ritmus; Studio = nagyobb lélegzet, xclean-studio-page.
 * @param {"classic"|"studio"} ui
 * @param {"default"|"calendar"|"tight"} spacing — calendar = kompaktabb klasszikus (naptár)
 */
export function studioPageRootClass(ui, spacing = "default") {
  const classic =
    spacing === "calendar"
      ? "space-y-3 sm:space-y-4"
      : spacing === "tight"
        ? "space-y-3 sm:space-y-5"
        : "space-y-4 sm:space-y-6";

  if (ui === "studio") {
    return cn("space-y-6 xclean-studio-page");
  }
  return classic;
}
